import { RouteConfig } from "vue-router";

export const RCompanyServices: RouteConfig = {
  path: "services",
  name: "companiesCompanyServices",
  component: () =>
    import(
      /* webpackChunkName: "companies-template-company-services" */
      "./VCompanyServices.vue"
    ),
  meta: {
    label: "services",
    title: "Companies",
  },
};
